const prefix = '[workspace] ';

export const CHANGE_SELECTION = `${prefix}CHANGE_SELECTION`;
// connections
export const CONNECTIONS_FETCH = `${prefix}CONNECTIONS_FETCH`;
export const CONNECTIONS_SELECT = `${prefix}CONNECTIONS_SELECT`;
export const CONNECTIONS_ARCHIVE = `${prefix}CONNECTIONS_ARCHIVE`;

// channels
export const CHANNELS_FETCH = `${prefix}CHANNELS_FETCH`;
export const CHANNELS_SELECT = `${prefix}CHANNELS_SELECT`;
export const CHANNELS_SELECT_SAVE = `${prefix}CHANNELS_SELECT_SAVE`;
export const CHANNELS_RESET = `${prefix}CHANNELS_RESET`;
export const CHANNELS_ARCHIVE = `${prefix}CHANNELS_ARCHIVE`;

// conversations
export const CONVERSATIONS_FETCH = `${prefix}CONVERSATIONS_FETCH`;
export const CONVERSATIONS_RESET = `${prefix}CONVERSATIONS_RESET`;
export const CONVERSATIONS_READ = `${prefix}CONVERSATIONS_READ`;
export const CONVERSATIONS_READ_WITH_PARAMS = `${prefix}CONVERSATIONS_READ_WITH_PARAMS`;

// messages
export const MESSAGE_CREATE = `${prefix}MESSAGE_CREATE`;
export const MESSAGE_DELETE = `${prefix}MESSAGE_DELETE`;
export const MESSAGE_DISABLE = `${prefix}MESSAGE_DISABLE`;
export const MESSAGE_ADD_FILES_TO_CONTRACT = `${prefix}MESSAGE_ADD_FILES_TO_CONTRACT`;

// contract
export const CONTRACT_SELECT = `${prefix}CONTRACT_SELECT`;

// unread headers
export const STATUS_MESSAGES = `$[topbar] STATUS_MESSAGES`;
export const STATUS_MESSAGES_REMOVE_CONNECTION = `$[topbar] REMOVE_CONNECTION`;
export const STATUS_CONNECTIONS_MARK_READ = '[topbar] MARK_ACCEPTED_AS_READ';



// WEBPACK FOOTER //
// ./src/app/components/workspace/store/constants.js